export default __webpack_public_path__ + "media/react/gre/adaptive_prep_v1/assets/notes_illustration-b73f9220d3dd5627ade2b6b766206c5f.svg";